import * as ngCore from '@angular/core'
import * as ds from '@attain-apps/fe/web/main/lib/design'

import * as state from '../../../../../../../state'
import { LayoutStore } from '../layout-store'

/**
 * TODO:
 */
@ngCore.Component({
  imports: [ds.overlay.slideout.Component, ds.input.select.multiple.Component],
  selector: 'atn-allocation-filters-slideout',
  standalone: true,
  styleUrls: ['./component.scss'],
  templateUrl: './component.html',
})
export class Component {
  /** @see {@link state.summit.allocations.Feature} */
  public readonly allocationsFeature = ngCore.inject(
    state.summit.allocations.Feature,
  )

  /** @see {@link LayoutStore} */
  public readonly layoutStore = ngCore.inject(LayoutStore)

  /** TODO:  */
  public readonly selectedFiltersSg = ngCore.model(
    state.summit.allocations.models.UnitOutcomeAssignment.Filter.DEFAULTS,
  )

  /** TODO:  */
  public readonly filters =
    state.summit.allocations.models.UnitOutcomeAssignment.Filter.ALL.map<
      ds.input.select.models.Item<
        state.summit.allocations.models.UnitOutcomeAssignment.Filter[number]
      >
    >(filter => ({
      label: filter,
      value: filter,
    }))

  constructor() {
    ngCore.effect(() => {
      const filters = this.selectedFiltersSg()

      this.allocationsFeature.actions.setAssignmentsFilters
        .from('AtnSummitAllocationPage.filtersSlideout.assignments.changed')
        .dispatch({ filters })
    })
  }
}
